var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.581,
    height: 11.179,
    viewBox: "0 0 14.581 11.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M12.8-14H1.783A1.791,1.791,0,0,0,0-12.2v7.586a1.791,1.791,0,0,0,1.783,1.8H12.8a1.791,1.791,0,0,0,1.783-1.8V-12.2A1.789,1.789,0,0,0,12.8-14Zm.968,9.383a.973.973,0,0,1-.968.976H1.783a.973.973,0,0,1-.968-.976V-12.2a.973.973,0,0,1,.968-.976H12.8a.973.973,0,0,1,.968.976v7.583Z",
    transform: "translate(0 14)",
    fill: "#ea555f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    d: "M-512-169.593H1043.326V-4693H-512Z",
    transform: "translate(512 4693)",
    fill: "#ea555f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M9.485-8.047l3.553-3.232a.418.418,0,0,0,.03-.582.4.4,0,0,0-.574-.03l-4.9,4.461L6.639-8.3s-.006-.006-.006-.009a.6.6,0,0,0-.066-.058L2.678-11.895a.4.4,0,0,0-.574.034.415.415,0,0,0,.033.582l3.595,3.26-3.58,3.4a.418.418,0,0,0-.018.582.412.412,0,0,0,.3.131.4.4,0,0,0,.277-.11L6.341-7.464l.986.893a.4.4,0,0,0,.271.1.4.4,0,0,0,.271-.107l1.013-.921,3.613,3.482a.4.4,0,0,0,.28.113.4.4,0,0,0,.295-.128.418.418,0,0,0-.015-.582Z",
    transform: "translate(-2 12)",
    fill: "#ea555f",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28597",
    "data-name": "Group 28597",
    transform: "translate(0 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345",
    transform: "translate(0 -14)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344",
    transform: "translate(-414.754 -3790.297)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    "data-name": "Path 3618",
    d: "M-5-19H17.682V.28H-5Z",
    transform: "translate(415.703 3805.247)",
    fill: "#ea555f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347",
    transform: "translate(1.62 -12.38)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346",
    transform: "translate(-416.374 -3791.917)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M-3-17H16.28V-.8H-3Z",
    transform: "translate(415.323 3804.867)",
    fill: "#ea555f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.157c5706b7faaa4754671559dfd73ecb.svg";
export { ForwardRef as ReactComponent };